import React, { useEffect, useState } from 'react';

import { PageHeader, Skeleton } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { getChargePointGroupDetail } from '../../hooks/chargepointGroups';
import { getConnectorTypes } from '../../hooks/connectors';
import StationGroupConfigForm from '../organisms/StationGroupConfigForm';


const StationGroupEditPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;

  h1 {
    font-size: 24px;
  }
`;

const StationGroupEditPage = () => {
  const { id } = useParams();
  const [chargePointGroup, setChargePointGroup] = useState(null);
  const history = useHistory();

  useEffect(() => {
    ;(async function () {
      setChargePointGroup(await getChargePointGroupDetail(id));
    })();
  }, [id]);

  if (chargePointGroup === null)
    return (
      <StationGroupEditPageWrapper>
        <Skeleton active />
      </StationGroupEditPageWrapper>
    );

  if (chargePointGroup?.error)
    return (
      <StationGroupEditPageWrapper>
        <p>Nenhum grupo de caregador encontrado com este id.</p>
      </StationGroupEditPageWrapper>
    );

  const {
    chargeBoxGroupPk,
    name,
    status,
    address,
    externalId,
    locationLatitude,
    locationLongitude
  } = chargePointGroup.details;

  var city, houseNumber, state, street, zipCode;

  if(address!=null) {
    city = address.city;
    houseNumber = address.houseNumber;
    state = address.state;
    street = address.street;
    zipCode = address.zipCode;
  }

  const initialValues = {
    ...chargePointGroup.details,
    chargeBoxGroupPk: chargeBoxGroupPk,
    name: name,
    status: status,
    address: {
      city: city || '',
      country: 'BR',
      empty: false,
      houseNumber: houseNumber || '',
      state: state || '',
      street: street || '',
      zipCode: zipCode || '',
    },
    externalId: externalId,
    locationLatitude: locationLatitude,
    locationLongitude: locationLongitude
  };

  return (
    <StationGroupEditPageWrapper>
      <PageHeader className='site-page-header' onBack={() => history.goBack()} title={T('Editing Chargebox Group')} subTitle={name} />
      <StationGroupConfigForm initialValues={initialValues} type='update' chargeBoxGroupPk={id} />
    </StationGroupEditPageWrapper>
  );
};

export default StationGroupEditPage;
